import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';
import { LargeBold, SmallBold, SmallRegular } from './GettingStarted';

const FAQs = () => {
    const [currentTab, setCurrentTab] = useState('General');
    const tabs = ['General', 'Jobseekers', 'Employers'];
    const handleClick = (e: any) => {
        setCurrentTab(e.target.innerText);
        // console.log(e)
    };
    return (
        <Box width="100%">
            <Box mb={{xs: '15px', sm:"28px"}}>
                <LargeBold>{`FAQ (${currentTab})`}</LargeBold>
            </Box>
            <Box mb={{xs: '36px', sm: "45px"}} p="15px 20px" width="100%">
                <Box
                    p={{xs:'2px', sm:"4px"}}
                    border="1px solid #C5C5C5"
                    borderRadius="12px"
                    bgcolor="#fff"
                    width="100%"
                >
                    <Box display="flex" width="100%" height="100%">
                        {tabs.map((tab, i) => (
                            <Box
                                key={tab}
                                width="100%"
                                height="100%"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                sx={{
                                    borderTopLeftRadius: i === 0 ? '8px' : 0,
                                    borderTopRightRadius:
                                        i === tabs.length - 1 ? '8px' : 0,
                                    borderBottomLeftRadius: i === 0 ? '8px' : 0,
                                    borderBottomRightRadius:
                                        i === tabs.length - 1 ? '8px' : 0
                                }}
                                py="15px"
                                bgcolor={
                                    currentTab === tab ? '#03384E' : '#EDEDED'
                                }
                                onClick={handleClick}
                            >
                                <Typography
                                    fontSize="14px"
                                    fontWeight={currentTab === tab ? 600 : 400}
                                    color={
                                        currentTab === tab ? '#fff' : '#808080'
                                    }
                                >
                                    {tab}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
            <Box>
                {currentTab === 'General' && (
                    <Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    1. What is the Jobfactor Score?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Jobfactor Score is not just a number; it's your
                                key to precision in job fits. Your Jobfactor
                                Score, like a FICO score for jobs, reflects your
                                complete profile, connections, and activities on
                                the platform. The higher your score, the more
                                you stand out to potential employers. Showcase
                                your skills, connect with value-aligned
                                employers, and let your Jobfactor Score
                                revolutionize your job search or recruitment
                                process. Your Jobfactor Score dashboard is where
                                the magic happens. Monitor your progress,
                                understand the factors influencing your score,
                                and take actions to boost it. Your Jobfactor
                                Score is your personal success tracker. You can
                                find your Jobfactor Score dashboard in the
                                navigation under Profile.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    2. What is the importance of Reviews and
                                    Feedback on Jobfactor?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                The peer review process is a cornerstone of our
                                ecosystem. Professionals can share achievements
                                and request peer reviews from their connections,
                                adding to their Jobfactor Score. These reviews
                                come with feedback from your reviewers which can
                                help you improve your skills. For employers,
                                this is a pool of references to confirm a
                                candidate's skills and competency. Basically
                                reviews and feedback gives us all the
                                opportunity to grow and succeed together. We
                                encourage users to provide honest feedback, and
                                we have measures in place to ensure the
                                authenticity of reviews. However, we always
                                recommend conducting your own due diligence.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    3. Why do I need Jobfactor analytics?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Understand how your profile is performing, track
                                the impact of your achievements, and make
                                informed decisions. Analytics is your tool for
                                data-driven success on the Jobfactor platform.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    4. How can I brand company on Jobfactor?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                For employers, you can "Build Your Brand" by
                                crafting a compelling company profile. Share
                                insights, values, and culture to attract the
                                right talent. Build your brand on Jobfactor.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    5. Is Jobfactor free to use for all?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Yes, job seekers and employers can use Jobfactor
                                features for free.  As we add more advanced
                                features, users may take advantage of these
                                advanced features for a fee. For more
                                information about pricing and timeline for
                                advanced features roll out, please{' '}
                                <a
                                    href=""
                                    style={{
                                        color: '#05668D',
                                        textDecoration: 'none',
                                        display: 'inline'
                                    }}
                                >
                                    contact our team
                                </a>
                                .
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    6. Can I use Jobfactor from anywhere in the
                                    world?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Yes, Jobfactor is a global platform accessible
                                from various countries. However, we may have
                                limited technical or sales support outside of
                                the United States at this time.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    7. How does the AI matching system work on
                                    Jobfactor?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Our AI analyzes job listings and user profiles
                                to match job seekers with relevant positions
                                based on Jobfactor score, skills, value
                                alignment, and user preferences.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    8. Are there mobile apps available for
                                    Jobfactor?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Jobfactor is currently not available for
                                download as a mobile app on the iOS and Android
                                app marketplaces. However, both professional and
                                company users can conveniently access Jobfactor
                                responsive and intuitive design on mobile
                                devices and any other interfaces.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    9. Does Jobfactor offer additional resources
                                    for career development?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Jobfactor provides resources such as articles,
                                webinars, and courses to help job seekers and
                                employers enhance their skills and recruitment
                                strategies.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    10. Can I delete my Jobfactor account if I
                                    no longer wish to use the platform?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Jobfactor provides resources such as articles,
                                webinars, and courses to help job seekers and
                                employers enhance their skills and recruitment
                                strategies.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    11. What should I do if I encounter
                                    technical issues on Jobfactor?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                If you experience technical problems, please
                                reach out to our{' '}
                                <a
                                    href=""
                                    style={{
                                        color: '#05668D',
                                        textDecoration: 'none',
                                        display: 'inline'
                                    }}
                                >
                                    support team
                                </a>{' '}
                                for assistance.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    12. How can I stay updated on Jobfactor news
                                    and updates?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                You can follow Jobfactor on social media and
                                subscribe to our{' '}
                                <a
                                    href=""
                                    style={{
                                        color: '#05668D',
                                        textDecoration: 'none',
                                        display: 'inline'
                                    }}
                                >
                                    newsletter
                                </a>{' '}
                                for the latest news and platform updates. You
                                can also join our community on Discord or our
                                various social media platforms.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    13. Does Jobfactor offer any premium
                                    features for job seekers or employers?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Jobfactor offers premium features with
                                additional benefits for both job seekers and
                                employers. Details can be found on our{' '}
                                <a
                                    href=""
                                    style={{
                                        color: '#05668D',
                                        textDecoration: 'none',
                                        display: 'inline'
                                    }}
                                >
                                    website
                                </a>
                                .
                            </SmallRegular>
                        </Box>
                    </Box>
                )}
                {currentTab === 'Jobseekers' && (
                    <Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    1. What is Jobfactor, and how can it help me
                                    find a job?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Jobfactor a modernized Skill-based on-demand job
                                marketplace that replaces keyword-based
                                technology using gamification and AI to connects
                                job seekers with employers. Our AI-driven
                                matching algorithm helps you find job
                                opportunities that align with your skills,
                                values, and cultural fit, much like how online
                                stores recommend products. Our proprietary
                                algorithmic Jobfactor score, like FICO score is
                                foundational to our skill-based, comprehensive
                                approach to job-fit.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    2. ‌How do I create a profile on Jobfactor?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                You can create a profile by signing up on the
                                Jobfactor website www.jobfactor.com using a
                                desktop computer, tablet or mobile devices.
                                Simply provide your email address or sign up
                                with your Google or LinkedIn profile. When
                                signing up, we highly recommend you provide as
                                much detailed on your profile as possible to get
                                started. This include work history, education,
                                job preferences. Once your account has been
                                created, you will be prompted to grow your
                                network by inviting coworkers to be part of your
                                Jobfactor community. This helps to enhance your
                                online credibility and better experience on
                                Jobfactor
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    3. What makes my Jobfactor profile different
                                    from a traditional resume?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Your Jobfactor profile is dynamic and showcases
                                your real work accomplishments rather than a
                                static resume. It provides a more holistic view
                                of your professional journey. Each time you have
                                a work achievement such as acquiring a new
                                skill, completing a new project, won a contract
                                or an award, Jobfactor gives you a platform to
                                celebrate those achievements with a vibrant
                                community of your coworkers who are motivated to
                                share that moment with you and give you
                                objective reviews. Those reviews become part of
                                your Jobfactor score and later serve as a pool
                                of reference for future employers to use as
                                confirmation of your skills and competency.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    4. Can I apply for jobs on Jobfactor without
                                    creating a profile?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                No, you need to create a profile to apply for
                                jobs through Jobfactor. This ensures that job
                                matches are tailored to your skills and
                                preferences. To have the best experience on
                                Jobfactor, you will need to have an active
                                profile, with at least 10 connections from your
                                current or past employment, school, supplier or
                                customer organizations with whom you can
                                exchange mutual feedback on each other's
                                accomplishments.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    5. ‌How do I apply for jobs on Jobfactor?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                For jobs posted by employers on Jobfactor, we
                                used a skill-based job fit algorithm to match
                                you with the job most suitable for your skills
                                and where you are most likely to succeed. You
                                will see these jobs in the recommended jobs
                                section on your profile.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    6. How can I increase my chances of getting
                                    noticed by employers on Jobfactor?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Ensure your profile is complete and showcases
                                your skills and accomplishments regularly. Use a
                                professional profile picture, connect with as
                                many as possible collogues from your past and
                                present jobs to join your network and stay
                                active on the platform by regularly sharing work
                                accomplishments, requesting reviews and
                                providing reviews on behalf of others in your
                                Jobfactor community.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    7. Is my data safe on Jobfactor?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Yes, we take data security seriously. Your
                                information is protected through robust security
                                measures. You can learn more about our privacy
                                policy on our website.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    8. How can I contact Jobfactor for support
                                    or inquiries?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                You can reach out to our support team through
                                the contact information provided on our website
                                or within the platform.
                            </SmallRegular>
                        </Box>
                    </Box>
                )}
                {currentTab === 'Employers' && (
                    <Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    1. What is Jobfactor, and how can it help my
                                    company find talent?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Jobfactor is an AI-powered talent marketplace
                                that connects employers with skilled
                                professionals. It simplifies the recruitment
                                process by matching you with candidates who meet
                                your specific job requirements.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    2. ‌How do I create an employer account on
                                    Jobfactor?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                You can create an employer account by signing up
                                on the Jobfactor website or app. Provide your
                                company details and start posting job listings.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    3. Can I search for candidates on Jobfactor
                                    without posting a job?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Yes, you can search for candidates using
                                Jobfactor's advanced search and matching
                                features without posting a job. This can help
                                you discover potential talent for future
                                positions.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    4. How does the "No Hire, No Pay" guarantee
                                    work for employers?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                If you're an employer and you don't hire a
                                candidate through Jobfactor, you won't be
                                charged any fees for using our platform. You
                                only pay when you successfully hire a candidate.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    5. ‌How do I post a job on Jobfactor?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                You can post a job by logging into your employer
                                account and following the steps provided. You'll
                                need to provide job details, qualifications, and
                                other relevant information.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    6. Can I customize the screening process for
                                    job applicants?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Yes, Jobfactor allows you to customize your
                                job's screening process to align with your
                                specific hiring needs.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    7. How do I communicate with job applicants
                                    on Jobfactor?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                You can communicate with applicants directly
                                through the platform's messaging system, making
                                it easy to coordinate interviews and share
                                information.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    8. What's the advantage of using Jobfactor
                                    for recruitment?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Jobfactor streamlines the recruitment process,
                                saving you time and effort. Our AI-driven
                                platform ensures you're matched with highly
                                qualified candidates, improving your chances of
                                making successful hires.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    9. Is my company's data secure on Jobfactor?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                Yes, we prioritize data security. Your company's
                                information is protected through robust security
                                measures. Learn more about our data security in
                                our privacy policy.
                            </SmallRegular>
                        </Box>
                        <Box mb="32px">
                            <Box mb="25px">
                                <SmallBold>
                                    10. How can I contact Jobfactor for employer
                                    support or inquiries?
                                </SmallBold>
                            </Box>
                            <SmallRegular>
                                You can reach out to our employer support team
                                using the contact information provided on our
                                website or within the platform. <br /> Note: If
                                you have any specific questions or require
                                further assistance, feel free to {' '}
                                <a
                                    href=""
                                    style={{
                                        color: '#05668D',
                                        textDecoration: 'none',
                                        display: 'inline'
                                    }}
                                >
                                    contact our support team
                                </a>
                                .
                            </SmallRegular>
                        </Box>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default FAQs;
